export default "__VITE_ASSET__ljLP7rpu__"